export const Footer = () => {
  return (
    <footer className="relative overflow-hidden border-t border-white/70 bg-gradient-to-r from-cyan-100/85 via-lime-100/75 to-pink-100/85 backdrop-blur-xl mt-auto py-10">
      <div className="absolute inset-x-0 top-0 h-1 bg-gradient-to-r from-cyan-300 via-lime-300 to-rose-300" />
      <div className="container mx-auto px-4 text-center space-y-2 relative z-10">
        <p className="text-slate-800 font-black">كنوز مصر - منصة تعليمية تفاعلية للأطفال</p>
        <p className="text-sm text-slate-600">© 2026 جميع الحقوق محفوظة</p>
        <p className="text-lg">🌟 📚 🗺️ 🎮</p>
      </div>
    </footer>
  );
};
